import uuid from 'react-uuid';
import { DynamoDBStatus } from "../constants/enums";
import { appNotification } from "../components/common/notification";
import { GENERAL_SERVER_ERROR } from '../constants/config';


export const historyList = async (): Promise<Conversation[] | null> => {

    const response = await fetch(import.meta.env.VITE_API_CONVERSATION_URL, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include"
    }).then((res) => {
        if (res.status === 401) {
            window.location.href = '/login';
        }
        return res.json();
    }).then((data) => {
        if (data.detail) {
            appNotification.error({ message: "Retrieving chat history", description: data.detail });
            return null
        }
        else {
            return data.data as Conversation[]
        }
    }).catch((err) => {
        console.error("There was an issue fetching your data.", err);
        appNotification.error({ message: "Retrieving chat history", description: GENERAL_SERVER_ERROR });
        return null
    })

    return response
}

export const mapChatMessageToSearchResult = (assistantMessage: ChatMessage): SearchResult => {
    // console.log("user message:", userMessage)
    // console.log("assistant message:", assistantMessage)

    let chatCitations: SearchResultCitation[] = []
    let generatedTextWithInLineCitations: (string | SearchResultCitation)[] = []
    if (assistantMessage.citations) {
        let running_number = 1
        let next_start = 0
        assistantMessage.citations.forEach((c) => {
            // console.log("citations:", c)
            c.references.forEach((r) => {
                const citation = {
                    display_type: r.s3_path[1],
                    main_title: r.s3_path[3],
                    encoded_url: r.s3_path[4],
                    no: running_number++,
                    start: c.start,
                    end: c.end,
                    content: r.content_text,
                    title: r.title,
                    url: r.url,
                    s3_path: r.s3_path,
                    chunk_id: r.chunk_id
                }

                chatCitations.push(citation);
                if (next_start <= c.start) {
                    generatedTextWithInLineCitations.push(assistantMessage.assistant_reply.slice(next_start, c.end - 1))
                }
                generatedTextWithInLineCitations.push(citation)
                next_start = c.end - 1
            })
        });
        if (next_start < assistantMessage.assistant_reply!.length) {
            generatedTextWithInLineCitations.push(assistantMessage.assistant_reply.slice(next_start))
        }
    }
    // console.log("chat Citations:", chatCitations)
    // console.log("generatedTextWithInLineCitations :", generatedTextWithInLineCitations)
    // console.log("assistantMessage:", assistantMessage)
    // console.log("userMessage:", userMessage)
    const searchResult: SearchResult = {
        id: uuid(),
        messageId: assistantMessage.message_id,
        userQuery: assistantMessage.user_query,
        generatedText: assistantMessage.assistant_reply,
        genratedTextWithInlineCitations: generatedTextWithInLineCitations,
        citations: chatCitations,
        classification: assistantMessage.classification,
        generatedTextCreatedAt: assistantMessage.createdAt,
        feedbackRating: assistantMessage.feedbackRating,
        feedbackComment: assistantMessage.feedbackComment,
        clipboardActivityCount: assistantMessage.clipboardActivityCount,
        toolsUsed: assistantMessage.tools_used,
        toolsResults: assistantMessage.tool_results, //TODO: Remove after testing
    }
    // console.log("searchResult:", searchResult)
    return searchResult
}

export const historyRead = async (convId: string): Promise<Conversation | null> => {
    const response = await fetch(`${import.meta.env.VITE_API_CONVERSATION_URL}/${convId}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include"
    })
        .then(async (res) => {
            if (!res.ok) {
                if (res.status === 401) {
                    window.location.href = '/login';
                }
                return []
            }
            return res.json()

        }).then((json) => {
            if (json.detail) {
                appNotification.error({ message: "Retrieving chat details", description: json.detail });
                return null
            }
            else {
                return json as Conversation
            }
        })
        .catch((err) => {
            console.error("There was an issue fetching your data.");
            appNotification.error({ message: "Retrieving chat details", description: GENERAL_SERVER_ERROR });

            return null
        })
    return response
}

export const historyGenerateStream = async (userMessage: ChatUserMessage | null, abortSignal: AbortSignal) => {

    return await fetch(import.meta.env.VITE_API_CONVERSATION_URL + '/stream', {
        method: "POST",
        headers: {
            "Content-Type": "application/stream+json",
        },
        credentials: "include",
        body: JSON.stringify(userMessage),
        signal: abortSignal
    }).then(async (res) => {
        if (res.status === 401) {
            window.location.href = '/login';
        }
        if (!res.ok) {
            const data = await res.json();
            if (data.detail) {
                appNotification.error({ message: "Search", description: data.detail });
            }
        }
        return res;
    }).catch((err) => {
        appNotification.error({ message: "Search", description: GENERAL_SERVER_ERROR });
        return new Response;
    });
}

export const historyGenerate = async (userMessage: ChatUserMessage, abortSignal: AbortSignal): Promise<ChatMessage | null> => {

    const response = await fetch(import.meta.env.VITE_API_CONVERSATION_URL, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(userMessage),
        signal: abortSignal
    }).then(async (res) => {
        if (res.status === 401) {
            window.location.href = '/login';
        }
        return res.json();
    }).then((json) => {
        if (json.detail) {
            appNotification.error({ message: "Search", description: json.detail });
            return null
        }
        else {
            return json as ChatMessage
        }
    }).catch((err) => {
        console.error("There was an issue fetching your data.");
        appNotification.error({ message: "Search", description: GENERAL_SERVER_ERROR });
        return null;
    })
    return response
}

export const classifyMessage = async (requestData: ClassificationRequest): Promise<Classification | null> => {
    return await fetch(import.meta.env.VITE_API_CLASSIFY_URL, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(requestData)
    }).then(async (res) => {
        if (res.status === 401) {
            window.location.href = '/login';
        }
        return res.json()
    }).then((json) => {
        if (json.detail) {
            appNotification.error({ message: "Search", description: json.detail });
            return null
        }
        else {
            return json as Classification
        }
    }).catch((err) => {
        console.error("There was an issue fetching your data.");
        appNotification.error({ message: "Search", description: GENERAL_SERVER_ERROR });
        return null;
    })
}

export const generateFollowUpQuery = async (conversationId: string, pastGeneratedQuestion: string[] = []): Promise<FollowupQuestions | null> => {

    return await fetch(`${import.meta.env.VITE_API_CONVERSATION_URL}/${conversationId}/generate-followup-query`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({ "questions": pastGeneratedQuestion })
    }).then(async (res) => {
        if (res.status === 401) {
            window.location.href = '/login';
        }
        return res.json()
    }).then((json) => {
        if (json.detail) {
            appNotification.error({ message: "Search", description: json.detail });
            return null
        }
        else {
            return json as FollowupQuestions
        }
    }).catch((err) => {
        console.error("There was an issue fetching your data.");
        appNotification.error({ message: "Search", description: "There was an issue fetching your data." });
        return null;
    })
}

export const generateMoreQuestions = async (faqList: string[]): Promise<FollowupQuestions> => {
    return await fetch(`${import.meta.env.VITE_API_BASE_URL}/generateMoreQuestions`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({ existingFaqs: faqList })
    }).then(async (res) => {
        if (res.status === 401) {
            window.location.href = '/login';
        }
        return res.json();
    }).catch((err) => {
        console.error("There was an issue fetching your data.");
        appNotification.error({ message: "Search", description: "There was an issue fetching your data." });
        return new Response();
    });
};


export const historyDelete = async (convId: string): Promise<Conversation | null> => {
    const response = await fetch(import.meta.env.VITE_API_CONVERSATION_URL, {
        method: "DELETE",
        body: JSON.stringify({
            id: convId,
        }),
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
    })
        .then((res) => {
            if (res.status === 401) {
                window.location.href = '/login';
            }
            return res.json()
        }).then((json) => {
            if (json.detail) {
                appNotification.error({ message: "Delete chat history", description: json.detail });
                return null
            }
            else {
                return json as Conversation
            }
        })
        .catch((err) => {
            console.error("There was an issue fetching your data.");
            appNotification.error({ message: "Delete chat history", description: GENERAL_SERVER_ERROR });

            return null;
        })
    return response;
}

export const historyDeleteAll = async () => {
    const response = await fetch(import.meta.env.VITE_API_CONVERSATION_URL + '/all', {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            // "x-ms-client-principal-id": await getSetUserIdCookie() ?? ""
        },
        credentials: "include",
    })
        .then((response) => {
            if (!response.ok) {
                if (response.status === 401) {
                    window.location.href = '/login';
                }
                else {
                    throw new Error('One or more records could not be deleted.');
                }
            }
            return { isSuccess: true };
        })
        .catch((err) => {
            console.error("There was an issue fetching your data.");
            appNotification.error({ message: "Delete chat history", description: GENERAL_SERVER_ERROR });
            return { isSuccess: false };
        })
    return response;
}

export const historyRename = async (convId: string, title: string): Promise<Response> => {
    const response = await fetch(import.meta.env.VITE_API_CONVERSATION_URL + "/", {
        method: "PUT",
        body: JSON.stringify({
            conversation_id: convId,
            title: title
        }),
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
    })
        .then((res) => {
            if (response.status === 401) {
                window.location.href = '/login';
            }
            return res
        })
        .catch((err) => {
            console.error("There was an issue fetching your data.");
            appNotification.error({ message: "Rename chat", description: GENERAL_SERVER_ERROR });
            let errRes: Response = {
                ...new Response,
                ok: false,
                status: 500,
            }
            return errRes;
        })
    return response;
}

export const historyEnsure = async (): Promise<DynamoDBHealth> => {
    const response = await fetch(import.meta.env.VITE_API_HEALTHCHECK_URL, {
        method: "GET",
        credentials: "include",
    })
        .then(async res => {
            let respJson = await res.json();
            let formattedResponse;
            if (respJson.message) {
                formattedResponse = DynamoDBStatus.Working
            } else if (res.status === 500) {
                formattedResponse = DynamoDBStatus.NotWorking
            } else {
                formattedResponse = DynamoDBStatus.NotConfigured
            }

            if (!res.ok) {
                if (response.status === 401) {
                    window.location.href = '/login';
                }
                return {
                    dynamoDB: false,
                    status: formattedResponse
                }
            } else {
                return {
                    dynamoDB: true,
                    status: formattedResponse
                }
            }
        })
        .catch((err) => {
            console.error("There was an issue fetching your data.");
            appNotification.error({ message: "Server", description: GENERAL_SERVER_ERROR });
            return {
                dynamoDB: false,
                status: err
            }
        })
    return response;
}

const login = async (username: string, password: string): Promise<Response> => {
    const response = await fetch(`${import.meta.env.VITE_API_BASE_URL}/login`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
            username: username,
            password: password
        })
    }).catch((err: any) => {
        console.error("API error during login:", err);
        console.log("login appNotification:", appNotification);
        appNotification.error({ message: "Server", description: GENERAL_SERVER_ERROR });
        return err;
    });
    return response;
}

const userMe = async (): Promise<Response | null> => {
    const response = await fetch(`${import.meta.env.VITE_API_USER_URL}/me`, {
        method: "GET",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
    }).catch((err) => {
        console.error("There was an issue fetching your data.");
        appNotification.error({ message: "Error", description: GENERAL_SERVER_ERROR });
        return err;
    })
    return response;
}

const logOut = async (): Promise<Response> => {
    const response = await fetch(`${import.meta.env.VITE_API_BASE_URL}/logout`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
    })

    return response;
}

const changePassword = async (oldPassword: string, newPassword: string, confirmNewPassword: string): Promise<Response> => {
    const response = await fetch(`${import.meta.env.VITE_API_BASE_URL}/changepassword`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
            password: oldPassword,
            new_password: newPassword,
            confirm_password: confirmNewPassword
        })
    }).catch((err) => {
        console.error("There was an issue fetching your data.");
        appNotification.error({ message: "Server", description: "Server unavailable. Please check network connection and try again." });

        return err;
    })
    return response;
}

const updateFeedback = async (requestData: FeedbackRequest): Promise<ChatMessage | null> => {
    const response = await fetch(`${import.meta.env.VITE_API_CONVERSATION_URL}/submit-feedback`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(requestData)
    }).then((res) => {
        if (res.status === 401) {
            window.location.href = '/login';
        }
        return res.json();
    }).then((data) => {
        if (data.detail) {
            appNotification.error({ message: "Feedback", description: data.detail });
            return null
        }
        else {
            return data as ChatMessage
        }
    }).catch((err) => {
        console.error("There was an issue fetching your data.", err);
        appNotification.error({ message: "Feedback", description: GENERAL_SERVER_ERROR });
        return null;
    })
    return response;
}

const updateClipboardActivity = async (requestData: ClipboardActivityRequest): Promise<ChatMessage | null> => {
    const response = await fetch(`${import.meta.env.VITE_API_CONVERSATION_URL}/track-clipboard-activity`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(requestData)
    }).then((res) => {
        if (res.status === 401) {
            window.location.href = '/login';
        }
        return res.json();
    }).then((data) => {
        if (data.detail) {
            // appNotification.error({ message: "ClipboardActivity", description: data.detail });
            return null
        }
        else {
            return data as ChatMessage
        }
    }).catch((err) => {
        console.error("There was an issue fetching your data.", err);
        // appNotification.error({ message: "ClipboardActivity", description: GENERAL_SERVER_ERROR });
        return null;
    })
    return response;
}

const getFAQs = async (agentId: string): Promise<FAQ | null> => {
    const response = await fetch(`${import.meta.env.VITE_API_FAQ_URL}/${agentId}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include"
    }).then((res) => {
        if (res.status === 401) {
            window.location.href = '/login';
        }
        return res.json();
    }).then((data) => {
        if (data.detail) {
            appNotification.error({ message: "Retrieving FAQs", description: data.detail });
            return null
        }
        else {
            return data as FAQ
        }
    }).catch((err) => {
        console.error("There was an issue fetching your data.", err);
        appNotification.error({ message: "Retrieving FAQs", description: GENERAL_SERVER_ERROR });
        return null
    })
    return response; // Return an empty array or appropriate value
}
export const getAllTopQueries = async (): Promise<FAQ[] | null> => {
    const response = await fetch(`${import.meta.env.VITE_API_FAQ_URL}/`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include"
    }).then((res) => {
        if (res.status === 401) {
            window.location.href = '/login';
        }
        return res.json();
    }).then((data) => {
        if (data.detail) {
            appNotification.error({ message: "Retrieving FAQs", description: data.detail });
            return null
        }
        else {
            return data.data as FAQ[]
        }
    }).catch((err) => {
        console.error("There was an issue fetching your data.", err);
        appNotification.error({ message: "Retrieving FAQs", description: GENERAL_SERVER_ERROR });
        return null
    })
    return response; // Return an empty array or appropriate value
}

export { login, userMe, logOut, changePassword, updateFeedback, getFAQs, updateClipboardActivity };